import ModeFull from 'marketing-website/components/icons/ModeFull';
import image01a from 'marketing-website/media/images/pages/case-studies/mode/image-01-a@2x.jpg';
import image01b from 'marketing-website/media/images/pages/case-studies/mode/image-01-b@2x.jpg';
import image03 from 'marketing-website/media/images/pages/case-studies/mode/image-03@2x.jpg';
import image04a from 'marketing-website/media/images/pages/case-studies/mode/image-04-a@2x.jpg';
import image04b from 'marketing-website/media/images/pages/case-studies/mode/image-04-b@2x.jpg';
import image05a from 'marketing-website/media/images/pages/case-studies/mode/image-05-a@2x.jpg';
import image05b from 'marketing-website/media/images/pages/case-studies/mode/image-05-b@2x.jpg';
import modeStats from 'marketing-website/media/images/pages/case-studies/mode/stats@2x.jpg';
import quote from 'marketing-website/media/images/pages/case-studies/mode/quote@2x.jpg';

const modeAssets = {
  heroLogo: ModeFull,
  statsImage: {
    alt: 'Mode employee’s working in open office space',
    maxWidth: 1290,
    src: modeStats,
  },
  singleImages: {
    first: {
      src: image03,
      maxWidth: 1141,
      alt: 'A meeting in Mode',
    },
  },
  doubleImages: {
    first: [
      {
        src: image01a,
        maxWidth: 536,
        alt: 'Person working with charts and analytic tools',
      },
      {
        src: image01b,
        maxWidth: 551,
        alt: 'People working with charts and analytic tools',
      },
    ],
    second: [
      {
        src: image04a,
        maxWidth: 600,
        alt: 'Developer uses Handoff with Marvel',
      },
      {
        src: image04b,
        maxWidth: 600,
        alt: 'Prototyping with Marvel at Mode',
      },
    ],
    third: [
      {
        src: image05a,
        maxWidth: 600,
        alt: 'Mode employees working with analytics',
      },
      {
        src: image05b,
        maxWidth: 600,
        alt: 'Mode employees working with analytics',
      },
    ],
    fourth: [
      {
        src: quote,
        maxWidth: 550,
        alt: '',
      },
      {
        maxWidth: 450,
        copy:
          '“Handoff is actually the biggest thing that we use on the product team. I can′t tell you how much time it saves in terms of making redlines or helping go back and forth with front-end engineering about anything from padding to colours to font weights."',
      },
    ],
  },
  stats: [
    {
      id: 0,
      stat: '1,260',
      title: 'comments',
      copy:
        'on Marvel prototypes between design, product managers, engineers, and marketing',
    },
    {
      id: 1,
      stat: '140',
      title: 'projects',
      copy: 'spanning various product areas and marketing functions',
    },
    {
      id: 2,
      stat: '3',
      title: 'hours',
      copy: 'of time saved per project with Prototypes and Handoff',
    },
  ],
};

export default modeAssets;



// WEBPACK FOOTER //
// ./src/configs/caseStudies/mode.js